import { Routes, Route, Navigate } from 'react-router';
import { useAuth } from './providers/auth-provider';

// Layouts
import { DashboardLayout } from './layouts/dashboard-layout';
import { AuthLayout } from './layouts/auth-layout';

// Auth Pages
import { LoginPage } from './pages/auth/login';

// Dashboard Pages
import { DashboardPage } from './pages/dashboard';
import { OrdersPage } from './pages/orders';
import { NewOrderPage } from './pages/orders/new';
import { OrderDetailPage } from './pages/orders/[id]';
import { ProjectsPage } from './pages/projects';
import { NewProjectPage } from './pages/projects/new';
import { ProjectDetailPage } from './pages/projects/[id]';
import { TraineesPage } from './pages/trainees';
import { NewTraineePage } from './pages/trainees/new';
import { TraineeDetailPage } from './pages/trainees/[id]';
import { ProductionPage } from './pages/production';
import { QualityPage } from './pages/quality';
import { CustomersPage } from './pages/customers';
import { NewCustomerPage } from './pages/customers/new';
import { ReportsPage } from './pages/reports';
import { SettingsPage } from './pages/settings';

// Settings Pages
import UsersPage from './pages/settings/users';
import InviteUserPage from './pages/settings/invite';

// Protected Route Wrapper
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

export function App() {
  return (
    <Routes>
      {/* Auth Routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>

      {/* Protected Dashboard Routes */}
      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/orders/new" element={<NewOrderPage />} />
        <Route path="/orders/:id" element={<OrderDetailPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/new" element={<NewProjectPage />} />
        <Route path="/projects/:id" element={<ProjectDetailPage />} />
        <Route path="/trainees" element={<TraineesPage />} />
        <Route path="/trainees/new" element={<NewTraineePage />} />
        <Route path="/trainees/:id" element={<TraineeDetailPage />} />
        <Route path="/production" element={<ProductionPage />} />
        <Route path="/quality" element={<QualityPage />} />
        <Route path="/customers" element={<CustomersPage />} />
        <Route path="/customers/new" element={<NewCustomerPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/settings/users" element={<UsersPage />} />
        <Route path="/settings/users/invite" element={<InviteUserPage />} />
      </Route>

      {/* Catch-all redirect */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
